import imagesLoaded from 'imagesloaded';
import Masonry from 'masonry-layout';

export default class SlabMasonry {
    constructor() {
        this.init();
    }

    init() {
        const grid = document.querySelector('.masonry');
        if (grid) {
            imagesLoaded(grid, () => {
                new Masonry(grid, {
                    itemSelector: '.masonry-item',
                    columnWidth: '.masonry-sizer',
                    percentPosition: true,
                    horizontalOrder: true,
                });
            });
        }
    }
}